export const extractMemberFromBettie = (
  bettieData: unknown
): { memberId: string; memberName: string } | null => {
  if (!bettieData || typeof bettieData !== 'object') return null;
  const bettieRecord = bettieData as Record<string, unknown>;
  const member = bettieRecord.member;
  if (!member || typeof member !== 'object') return null;
  const memberRecord = member as Record<string, unknown>;
  const memberId = memberRecord.memberId;
  const memberName = memberRecord.name;
  if (typeof memberId !== 'string') return null;
  if (typeof memberName !== 'string') return null;
  return { memberId, memberName };
};
